import React from 'react'

import styles from './modal.module.scss'

import { FiAlertCircle } from 'react-icons/fi';

interface Props {
    title: string,
    status: any,
    confirm: () => void,
    cancel: () => void,
    iconConfirmation: string
}


export const ConfirmationModal: React.FC<Props> = ({ title, status, confirm, cancel, iconConfirmation }) => {
    
    return (
        <React.Fragment>
            <div className={status}>
                <div className={styles.messageContainer}>
                    <div className={styles.pencilContainer}>
                        <div className={styles.alignIcon}>
                            <FiAlertCircle />
                        </div>
                    </div>
                    <div>
                        <h2>{title}</h2>
                    </div>
                    <div className={iconConfirmation === 'faPencilAlt' ? styles.buttonsContainerYellow : styles.buttonsContainerRed}>
                        <button className={styles.button} onClick={() => cancel()}>Não</button>
                        <button className={styles.button} onClick={() => confirm()}>Sim</button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}